var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCustomersWithTheMostOrders',{attrs:{"img_header":_vm.header_image,"header":"ลูกค้าที่มียอดสั่งซื้อมากที่สุด (Customers with the most orders)","link_back":"","check_link_back":"1"}}),_c('CustomerWithTheMostOrders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }